import { render } from "./VoteCard.vue?vue&type=template&id=5fe03fb9&scoped=true"
import script from "./VoteCard.vue?vue&type=script&lang=js"
export * from "./VoteCard.vue?vue&type=script&lang=js"

import "./VoteCard.vue?vue&type=style&index=0&id=5fe03fb9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe03fb9"]])

export default __exports__